import { createAsyncThunk } from "@reduxjs/toolkit";
import Liquid from '@liquidcloud/sdk';
import PubSub, { Message } from "../../../Utils/pubSub";
import { liquidRefreshProduct } from "../Product/store/thunks";
import { resetEngraving } from "../Product/store/productSlice";
import appConfig from "../../../Configs/app.config";

export const liquidClient = createAsyncThunk(
  'elements/liquidClient',
  async (token, { getState }) => {
    return await Liquid({
      clientId: token,
      env: appConfig.mockApi ? 'mock' : appConfig.environment
    })
  }
)

export const liquidAddressPredictions = createAsyncThunk(
  'product/liquidAddressPredictions',
  async ({ inputValue, callback }, { getState }) => {

    const { elements, auth } = getState()

    const predictions = await elements.liquid
      .address({ search: inputValue })

    if (!auth.configs.general.details) {
      predictions.length = Math.min(predictions.length, 4);
    }

    callback(
      predictions
        .map(({ description, placeId }) => ({
          label: description,
          value: placeId
        }))
    )
  }
)

export const liquidAddressDetails = createAsyncThunk(
  'product/liquidAddressDetails',
  async (selection, { getState }) => {

    const { elements } = getState()

    return await elements.liquid.address({ placeId: selection.value })
  }
)

export const liquidSaveAddress = createAsyncThunk(
  'product/liquidSaveAddress',
  async (address, { getState, dispatch }) => {

    const { elements: { liquid, cartId } } = getState()
    const cart = await liquid.cart({ id: cartId })
    await dispatch(liquidRefreshProduct({ address }));

    if (cart.cartItems.length > 0) {
      cart.cartItems = cart.cartItems.reduce((acc, item) => {
        return item.items?.length > 0 ?
          [...acc, ...item.items] :
          [...acc, item]
      }, []).map(item => ({
        ...item,
        quantity: 0
      }))

      liquid.cart(cart).then((cartResponse) => {
        PubSub.publish(Message.CartUpdated, { cart: cartResponse })
      })
    }

    dispatch(resetEngraving());

    PubSub.publish(Message.AddressChanged, { address })
    return address;
  }
);
